import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import {
  selectIsAuthenticated,
  selectIsAdmin,
  selectAuthLoading,
} from "../redux/slices/authSlice";

/**
 * Guards /admin on admin.betbond.app.
 * Unauthenticated visitors go to staff login — never Access Denied from a
 * leftover consumer session (admin auth is separate from betbond.app).
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isAdmin = useSelector(selectIsAdmin);
  const isLoading = useSelector(selectAuthLoading);
  const needsLogin = !isAuthenticated || !isAdmin;

  if (isLoading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ backgroundColor: "#0A0F18" }}
      >
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500 mx-auto mb-4" />
          <p className="text-white text-lg">Verifying access…</p>
        </div>
      </div>
    );
  }

  if (needsLogin) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default ProtectedRoute;
